import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

export const StyledButton = styled.div<{
  isCurrent: boolean;
}>(({
  isCurrent,

  theme: {
    colors,
    fonts,
    indents,
  },
}) => ({
  ...fonts.DEFAULT,
  display: 'block',
  width: '100%',
  boxSizing: 'border-box',
  margin: 0,
  paddingTop: 4,
  paddingBottom: 4,
  paddingLeft: indents.INDENT_2,
  paddingRight: indents.INDENT_2,
  backgroundColor: isCurrent ? colors.ACTION_BACKGROUND : 'transparent',
  color: colors.NEUTRAL_DEFAULT,
  cursor: 'pointer',
  outline: 'none',
  border: 'none',
  textAlign: 'left',

  ':hover': {
    backgroundColor: colors.ACTION_BACKGROUND,
    color: colors.NEUTRAL_DEFAULT,
  },

  ':active': {
    backgroundColor: colors.ACTION_BACKGROUND,
    color: colors.NEUTRAL_DEFAULT,
  },
}));

export type PageSizeOptionProps = {
  onSelect: (nextValue: number) => void;
  option: number;
  value: number;
};

export function PageSizeOption({
  onSelect,
  option,
  value,
}: PageSizeOptionProps): ReactElement {
  const onClick = (): void => {
    onSelect(option);
  };

  return (
    <StyledButton
      isCurrent={value === option}
      role="button"
      onClick={onClick}
      onKeyPress={onClick}
      tabIndex={0}
    >
      {option}
    </StyledButton>
  );
}
